/**
 * Builds the redirect URL to an eID provider's authorize endpoint — Criipto/Idura
 * MitID, NemID, BankID, and Suomi.fi / FTN all share this contract. It appends the
 * anonymous PropertyUser token as `api_key`, the return `redirect_url` (current
 * origin + path, trailing slash stripped), and the selected `property_id` when
 * present. The IdP redirects back to `redirect_url` with `?api_key=` so
 * UserStoreProvider can upgrade the anonymous session into a citizen session.
 *
 * Extracted from CriptioLogin (was the module-local `createMitIdLink`) so the
 * shadcn Suomi.fi surface (SuomiFiLogin) can share the exact same contract as the
 * legacy antd MitID/NemID/BankID buttons instead of duplicating it.
 */
export const buildEidRedirectUrl = (
  url: string,
  token: string,
  propertyId?: string | null
): string => {
  const cleanPathname = window.location.pathname.replace(/\/$/, '');
  const base = url.concat(
    `?api_key=${token}&redirect_url=${encodeURIComponent(
      `${window.location.origin}${cleanPathname}`
    )}`
  );
  return propertyId
    ? base.concat(`&property_id=${encodeURIComponent(propertyId)}`)
    : base;
};
